import { TimeFormatEnum } from 'common/components/entities/Calendar/constants'
import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export const createBookingCalendar = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
  type?:
    | EntityTypeEnum.BookingCalendar
    | EntityTypeEnum.BookingCalendarPreview
    | EntityTypeEnum.BookingCalendarReschedule
    | EntityTypeEnum.BookingPaidCalendar,
): BookingCalendarInterface | BookingPaidCalendarInterface => {
  const entity: BookingCalendarInterface | BookingPaidCalendarInterface = {
    ...generateBaseEntity(
      type || EntityTypeEnum.BookingCalendar,
      parentId,
      masterBlockId,
    ),
    padding: {
      paddingTop: 30,
      paddingRight: 30,
      paddingBottom: 30,
      paddingLeft: 30,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    margin: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
    },

    eventId: undefined,
    availableSlotBackgroundColor: 'rgba(241, 244, 248, 1)',
    selectedSlotBackgroundColor: 'rgba(0, 160, 255, 1)',
    titlesColor: 'rgba(20, 45, 99, 1)',
    mobileTitlesColor: 'rgba(20, 45, 99, 1)',
    color: 'rgba(20, 45, 99, 0.6)',
    mobileColor: 'rgba(20, 45, 99, 0.6)',

    calendarStepHeadline:
      'entities.calendar.calendar_step_headline_default_text',
    calendarStepSubHeadline:
      'entities.calendar.calendar_step_sub_headline_default_text',
    formStepHeadline: 'entities.calendar.form_step_headline_default_text',
    formStepSubHeadline:
      'entities.calendar.form_step_sub_headline_default_text',
    nextStepButtonText: 'entities.calendar.next_step_default_text',
    formButtonText: 'entities.calendar.form_submit_default_text',
    timeFormat: TimeFormatEnum.h24,

    fieldBorder: {
      color: 'rgba(158, 158, 158, 1)',
      style: BorderStyleEnum.solid,
      width: 1,
      radius: 5,
    },
    questions: [],

    thankYouStepButtonType: RedirectionTypesEnum.none,
    thankYouStepButtonText:
      'entity_settings.booking_calendar.thank_you_step_button_text',
    childIds: [],
  }

  return entity
}
